import script from "./AIBarCollapsed.vue?vue&type=script&setup=true&lang=js"
export * from "./AIBarCollapsed.vue?vue&type=script&setup=true&lang=js"

import "./AIBarCollapsed.vue?vue&type=style&index=0&id=15270109&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15270109"]])

export default __exports__